import {ClassNames} from '@emotion/react'
import Tooltip from '@material-ui/core/Tooltip'
import InfoOutlined from '@material-ui/icons/InfoOutlined'
import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import {TriggerButton, tooltipPopperCss} from './PerfFeeTooltip.styled'

type KpiMessage = {i18nKey: string; defaults: string}

type KpiInfoTooltipProps = {
  /** The i18n message spread onto {@link Trans} as the tooltip body — a one-sentence definition. */
  message: KpiMessage
  /** The KPI's name message, translated for the trigger's accessible label. */
  ariaMessage: KpiMessage
} & WithNamespaces

/**
 * Info icon that reveals a one-sentence plain-English definition of a KPI on hover or focus
 * (PT-5711 AC). Reuses the offer card's tooltip skin ({@link tooltipPopperCss}) so every tile's
 * hint looks like the existing performance-fee tooltip. The trigger's accessible label is
 * translated via `withNamespaces`, matching the rest of the tree's aria labels.
 *
 * @param message - The definition to show; a single sentence, translated via {@link Trans}.
 * @param ariaMessage - The KPI name message used as the trigger's translated aria-label.
 * @param t - Translation function injected by `withNamespaces`.
 */
const _KpiInfoTooltip = ({message, ariaMessage, t}: KpiInfoTooltipProps) => (
  <ClassNames>
    {({css}) => (
      <Tooltip
        arrow
        placement="top"
        title={<Trans {...message} />}
        classes={{tooltip: css(tooltipPopperCss)}}
      >
        <TriggerButton type="button" aria-label={t(ariaMessage.i18nKey, ariaMessage.defaults)}>
          <InfoOutlined style={{fontSize: 13}} />
        </TriggerButton>
      </Tooltip>
    )}
  </ClassNames>
)

export const KpiInfoTooltip = withNamespaces()(_KpiInfoTooltip)
